import getStore from '../data/store/store';
import BookingService from 'owa-service/lib/contract/BookingService';

/**
 * Util to get services from store.
 */
export default function getServices(): BookingService[] {
    return getStore().services;
}
